/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Standard_Benefit_TextInputs */



/**
* | output |
* | --- |
* | "Simple, predictable pricing for your entire organization. Flat rate includes unlimited users and usage." |
*
* @param {Pricing_Standard_Benefit_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_standard_benefit_text = /** @type {((inputs?: Pricing_Standard_Benefit_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Standard_Benefit_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einfache, planbare Preise für Ihre gesamte Organisation. Der Festpreis beinhaltet unbegrenzte Nutzer und Nutzung.")
	return /** @type {LocalizedString} */ ("Simple, predictable pricing for your entire organization. Flat rate includes unlimited users and usage.")
});